import { CommunityRepository } from '@amityco/js-sdk';
import useUser from '../../core/hooks/useUser';
import { canEditCommunity, canReviewCommunityPosts, isAdmin, isModerator, } from '../../helpers/permissions';
import useLiveObject from '../../core/hooks/useLiveObject';
import { isCommunityMember } from '../../helpers/utils';
const useCommunityOneMember = (communityId, currentUserId, communityOwnerId) => {
    const currentMember = useLiveObject(() => CommunityRepository.memberByCommunityIdAndUserId({ communityId, userId: currentUserId }), [communityId, currentUserId]);
    const { user } = useUser(currentUserId);
    const isCommunityModerator = isModerator(currentMember === null || currentMember === void 0 ? void 0 : currentMember.roles);
    const hasModeratorPermissions = (isCommunityMember(currentMember) && isCommunityModerator) ||
        isModerator(user === null || user === void 0 ? void 0 : user.roles) ||
        isAdmin(user === null || user === void 0 ? void 0 : user.roles);
    return {
        isCurrentMemberReady: !!currentMember.userId,
        currentMember,
        isCommunityModerator,
        hasModeratorPermissions,
        canEditCommunity: canEditCommunity({
            userId: currentUserId,
            user,
            communityUser: currentMember,
            community: { userId: communityOwnerId },
        }),
        canReviewCommunityPosts: canReviewCommunityPosts({
            userId: currentUserId,
            user,
            communityUser: currentMember,
            community: { userId: communityOwnerId },
        }),
    };
};
export default useCommunityOneMember;
//# sourceMappingURL=useCommunityOneMember.js.map